// @flow
import * as React from 'react';
import {StyleSheet, View} from 'react-native';
import Content from './Content';
import {Touchable} from 'trpc-react-native-ui';
import theme from '../../../theme-config';

const BaseFrame = (props: Props) => {
  const styles = getStyles();
  return (
    <View style={[styles.frame, props.style]}>
      {props.onFrameTouched && typeof props.onFrameTouched === 'function' ? (
        <Touchable onPress={props.onFrameTouched} underlayColor="white">
          <View>{props.children}</View>
        </Touchable>
      ) : (
        props.children
      )}
    </View>
  );
};

const getStyles = () =>
  StyleSheet.create({
    frame: {
      backgroundColor: theme.frame.backgroundColor,
      borderRadius: 3,
    },
  });

type Props = {
  onFrameTouched?: Function,
  children?: any,
  style?: any,
};

BaseFrame.Content = Content;

export default BaseFrame;
